import mutations from './mutations'
import apiMenues from '@/services/api/Menues'

const setMenues = function({ commit }, payload) {
    commit('SET_MENUES', payload)
}

const setShowSubmenues = function({commit}, index){
    commit('SET_SHOW_SUBMENUES', index)
}

const setTitleTopBar = function({commit}, newTitle){
    document.title = newTitle + " | Agroplastic"
    commit('SET_TITLE_TOP_BAR', newTitle)
}

const resetState = function({ commit }) {
    commit('RESET')
}

const fetchMenues = async function({dispatch }, moduleId) {
    let arrayMenues
    let response = await apiMenues.getMenues(moduleId)
    if(response.status === "success"){
        arrayMenues = response.data.g_menu_module_user
    }else{
        arrayMenues = [ {id:1, name: "No puede acceder a ninguna opción", icon:"error", route:'/', g_submenus: null}]
    }
    dispatch('setMenues', arrayMenues)
    console.log(arrayMenues)
}

/**
 * 
 */
const fetchMenu = function ( { dispatch }, moduleId ) {
    apiMenues.getMenues( moduleId ).then( function ( response ) {
        dispatch( "setMenu", response.data.g_menu_module_user )
    })
}

/**
 * 
 */
const setAppToolbarItems = function ({ commit }, { items }) {
    commit("SET_TOOLBAR_ITEMS", items)
}

/**
 * 
 */
const setAppToolbarTitle = function ({ commit }, { title }) {
    commit("SET_TITLE_TOP_BAR", title)
}

/**
 * 
 */
const setItemsTopBar = ( context, items ) => {
    context.commit( "SET_TOOLBAR_ITEMS", items )
}

/**
 * 
 */
const setMenu = function( { commit }, payload ) {
    commit( "SET_MENUES", payload)
}

//
export default {
    fetchMenu,
    setMenu,
    setMenues,
    resetState,
    fetchMenues,
    setShowSubmenues,
    setTitleTopBar,
    setAppToolbarItems,
    setAppToolbarTitle,
    setItemsTopBar,
}
